"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable react/require-default-props */

var CheckIcon = exports.CheckIcon = function CheckIcon(props) {
  var _props$color = props.color,
    color = _props$color === void 0 ? "#000000" : _props$color,
    _props$width = props.width,
    width = _props$width === void 0 ? 24 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 24 : _props$height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 6L9 17L4 12",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};